module.exports = __webpack_public_path__ + "static/media/ad-slide-03.ce73d6a5.jpg";